<!-- Edit line changeover modal -->
<ng-template #editLineChangeover let-modalProduct>
  <div class="modal-header">
     <h4 class="modal-title" id="modal-basic-title">{{ 'Admin.changeover_line' | translate }}</h4>
     <button type="button" class="modal_close close" aria-label="Close" (click)="closeModal(modalProduct)">
     <span aria-hidden="true"><em class="fa fa-times"></em></span>
     </button>
  </div>
  <div class="modal-body">
     <form method="post" (ngSubmit)="onSubmit(lineForm, modalProduct)" #lineForm="ngForm">
     <div class="row">
        <div class="col-md-12">
           <div class="form-group">
              <label class="label_grey">{{ 'Admin.line_name' | translate }}</label>
              <input type="text" name="line_name" id="line_name" class="form-control" [(ngModel)]="editLineObj.lineName" disabled>
           </div>
        </div>
     </div>
     <div class="row">
        <div class="col-md-12">
           <div class="form-group">
              <label class="label_grey">{{ 'Admin.product_code' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select class="form-control" name="productCode" tabindex="19" [(ngModel)]="productCode" (change)="onChangedProductValue($any($event.target).value)">
                     <option value="0" readonly disabled="true">{{ 'Admin.select-product-code-placeholder' | translate }}</option>
                     <option *ngFor="let data of productList" [value]="data.productCode">{{data.productCode}}</option>
                  </select>
              </div>
           </div>
           <div class="col-md-12">
              <div class="form-group">
                 <label class="label_grey">{{ 'Admin.Location' | translate }}<span class="mandatory">*</span></label>&nbsp;
                 <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                     <select class="form-control" name="areaType" tabindex="19" [(ngModel)]="areaType" (change)="onChangedAreaTypeValue($any($event.target).value)">
                        <option value="0" readonly disabled="true">{{ 'Admin.select-area-type-placeholder' | translate }}</option>
                        <option *ngFor="let data of areaTypeList" [value]="data.areaType">{{data.areaType}}</option>
                     </select>
                 </div>
              </div>
           </div>
           <div class="form-group">
              <div class="row my-3">
                 <div class="col-md-12 text-right">
                    <button 
                      class="btn btn-secondary" 
                      [disabled]="!isSubmitEnabled"
                      [class.btn-enabled]="isSubmitEnabled"
                      [class.btn-grey]="!isSubmitEnabled"
                      name="submit" 
                      id="submit">
                      Submit
                    </button>
                 </div>
              </div>
           </div>
        </div>
     </div>
     </form>
  </div>
</ng-template>
